__turbopack_context__.v({
  "btnLink": "styles-module-scss-module__Ii4Exq__btnLink",
  "content": "styles-module-scss-module__Ii4Exq__content",
  "root": "styles-module-scss-module__Ii4Exq__root",
  "text": "styles-module-scss-module__Ii4Exq__text",
  "title": "styles-module-scss-module__Ii4Exq__title",
});
